import React from 'react';

const SpacingBox = () => (
  <svg
    width="268"
    height="120"
    viewBox="0 0 268 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_558_12134)">
      <rect width="268" height="120" rx="4" fill="#F3F4F6"></rect>
      <rect x="32.5" y="32.5" width="203" height="55" stroke="#DDE0E4"></rect>
      <path d="M235.5 32.5L195.5 52.5" stroke="#DDE0E4"></path>
      <path d="M235.5 32.5L266.5 1.5" stroke="#DDE0E4"></path>
      <path d="M32.5 32.5L72.5 52.5" stroke="#DDE0E4"></path>
      <path d="M32.5 32.5L1.5 1.5" stroke="#DDE0E4"></path>
      <path d="M32.5 87.5L72.5 67.5" stroke="#DDE0E4"></path>
      <path d="M32.5 87.5L1.5 118.5" stroke="#DDE0E4"></path>
      <path d="M235.5 87.5L195.5 67.5" stroke="#DDE0E4"></path>
      <path d="M235.5 87.5L266.5 118.5" stroke="#DDE0E4"></path>
      <rect x="72.5" y="52.5" width="123" height="15" fill="white"></rect>
      <rect x="72.5" y="52.5" width="123" height="15" stroke="#DDE0E4"></rect>
    </g>
    <rect x="0.5" y="0.5" width="267" height="119" rx="3.5" stroke="#DDE0E4"></rect>
    <defs>
      <clipPath id="clip0_558_12134">
        <rect width="268" height="120" rx="4" fill="white"></rect>
      </clipPath>
      <clipPath id="clip1_558_12134">
        <rect x="32" y="32" width="204" height="56" fill="white"></rect>
      </clipPath>
    </defs>
  </svg>
);

export default SpacingBox;
